(function() {

  angular
  .module('meanApp')
  .factory('Department', Department);

  Department.$inject = ['$http', 'httpAuth', '$rootScope', 'Model'];
  function Department ($http, httpAuth, $rootScope, Model) {
    var Department = function (userData) {
        Model.apply(this, arguments);
    };

    Department.APIPath = 'departments';
    Department.prototype = {
        getAPIPath: function() {
            return Department.APIPath;
        }
    };
    
    angular.extend(Department.prototype, Model.prototype);

    return Department;
  };

})();